import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import ProgressiveImage from '@/ui/segments/landing/components/progressive-image/progressive-image';
import { IconPlus } from '@/ui/segments/landing/icons/icon-plus';
import { styleButtonHoverable } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import CategoryButton from './category-button';
import type { ContentForNewsItem } from '@/services/sanity/api/get-news-item';
import styles from './card.module.css';
interface CardsProps {
  className?: string;
  news: ContentForNewsItem;
}
export default function Cards(t0) {
  const $ = _c(41);
  const {
    className,
    news
  } = t0;
  const t1 = news.isEPFL && styles.small;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = classNames(className, styles.card, t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = news.slug ? `news-card-${news.slug}` : news.id ? `news-card-${news.id}` : undefined;
  let t4;
  if ($[3] !== news.title) {
    t4 = <h1>{news.title}</h1>;
    $[3] = news.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== news.date) {
    t5 = formatDate(news.date);
    $[5] = news.date;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div>Published {t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== news.category) {
    t7 = <CategoryButton disabled={true} className="text-gray-500">{news.category}</CategoryButton>;
    $[9] = news.category;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className={styles.subtitle}>{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== news.content) {
    t9 = <div><span>{news.content}</span></div>;
    $[14] = news.content;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = news.isExternalLink && news.link ? news.link : `/news/${news.slug}`;
  const t11 = news.isExternalLink ? "_blank" : undefined;
  const t12 = news.isExternalLink ? "noopener noreferrer" : undefined;
  const t13 = `Read more about ${news.title}`;
  let t14;
  let t15;
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = classNames(styleButtonHoverable, styles.button);
    t15 = <div>Read more</div>;
    t16 = <IconPlus />;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t14 = $[16];
    t15 = $[17];
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t12 || $[22] !== t13) {
    t17 = <Link href={t10} target={t11} rel={t12} aria-label={t13} className={t14}>{t15}{t16}</Link>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t17 || $[25] !== t9) {
    t18 = <div className={styles.text}>{t9}{t17}</div>;
    $[24] = t17;
    $[25] = t9;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== news.imageHeight || $[28] !== news.imageURL || $[29] !== news.imageWidth || $[30] !== news.title) {
    t19 = <ProgressiveImage forceAspectRatio={true} className={styles.image} src={news.imageURL} width={news.imageWidth} height={news.imageHeight} alt={news.title} />;
    $[27] = news.imageHeight;
    $[28] = news.imageURL;
    $[29] = news.imageWidth;
    $[30] = news.title;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t18 || $[33] !== t19) {
    t20 = <div className={styles.content}>{t18}{t19}</div>;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t2 || $[36] !== t20 || $[37] !== t3 || $[38] !== t4 || $[39] !== t8) {
    t21 = <div className={t2} data-testid={t3}>{t4}{t8}{t20}</div>;
    $[35] = t2;
    $[36] = t20;
    $[37] = t3;
    $[38] = t4;
    $[39] = t8;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
}
function formatDate(d: string) {
  const date = new Date(d);
  const fmt = new Intl.DateTimeFormat('en', {
    dateStyle: 'long'
  });
  return fmt.format(date);
}